import {Refine} from "@refinedev/core";
import {RefineKbar, RefineKbarProvider} from "@refinedev/kbar";
import "@refinedev/antd/dist/reset.css";

import {UnsavedChangesNotifier,} from "@refinedev/react-router-v6";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ReactElement} from "react";
import refineConfig from "./resources/refineConfig";
import Index from "./pages/Index";
import Connect from "./pages/Connect";
import Disconnect from "./pages/Disconnect";
import Success from "./pages/Success";


export default function App(): ReactElement | null {

    return (
        <BrowserRouter>
            <RefineKbarProvider>
                <Refine {...refineConfig(window.userprofile.url)}>
                    <Routes>
                        <Route index path="/" element={<Index/>} />
                        <Route path="/connect" element={<Connect/>} />
                        <Route path="/success" element={<Success/>}/>
                        <Route path="/logout" element={<Disconnect/>} />
                    </Routes>
                    <RefineKbar/>
                    <UnsavedChangesNotifier/>
                </Refine>
            </RefineKbarProvider>
        </BrowserRouter>
    );
}
